import { isMobile } from 'react-device-detect';
import { fabric } from 'fabric';
import editIconSVG from '../../../assets/edit-icon-button-48.svg';
import { getMobileFontSize } from '../../../components/card-editor/card-editor-utils';
import { FabricTextBox } from '../../../global-types';
import colorsList from '../../../styles/util.scss';
import { getFontName, CanvasDataTypes, getGroupedItemByName } from '../../../utils';

// TODO: Method needs to be refactor to move external dependencies up.

export type AddPhotoTextZoneButtonProps = {
  zone: fabric.Group & FabricTextBox;
  currentCanvas: fabric.Canvas;
  label?: string;
};

/** This creates a button for a PhotoTextZone and returns a promise that resolves when the button is added to the photo zone button
 * */
export const addPhotoTextZoneButton = ({ zone, currentCanvas, label }: AddPhotoTextZoneButtonProps): Promise<void> => {
  return new Promise((resolve) => {
    fabric.Image.fromURL(
      editIconSVG,
      (editIcon) => {
        editIcon.set({ originX: 'left', originY: 'center', left: 0, top: 0 });
        const buttonLabel = new fabric.Text(label || '', {
          textAlign: 'center',
          fontSize: !isMobile ? 15 : getMobileFontSize(currentCanvas),
          lineHeight: 25,
          fill: colorsList['dark-gray'],
          selectable: false,
          evented: false,
          originX: 'left',
          originY: 'center',
          top: 0,
          left: 0,
          fontFamily: getFontName(115), // this will get the BeamNewHMK-84 font
          objectCaching: true, // Necessary to avoid performance issues with OpenType.js
          name: CanvasDataTypes.PhotoTextZoneLabel,
          CanResizeTextArea: zone.CanResizeTextArea,
        } as FabricTextBox);
        // Set the width of the label to make sure it's always centered
        // some browsers (firefox) render text with a larger declared width, distorting the alignment
        if (!isMobile) {
          buttonLabel.width = 81;
        }

        const buttonGroup = new fabric.Group([editIcon, buttonLabel], {
          evented: false,
          name: CanvasDataTypes.PhotoTextZoneButton,
          hoverCursor: 'pointer',
          selectable: false,
          originX: 'center',
          originY: 'center',
          height: zone.height,
          left: zone.left,
          top: zone.top,
          angle: zone.angle,
          data: {
            linkedZoneName: zone.name,
          },
          objectCaching: false,
        });
        document.fonts.ready.then(() => {
          const originalText = getGroupedItemByName(CanvasDataTypes.PhotoZoneTextbox, zone) as fabric.Text;
          if (originalText.text && originalText.text.length > 0) {
            buttonGroup.visible = false;
            originalText.moveTo(0);
          } else {
            originalText.visible = false;
            buttonGroup.moveTo(0);
          }
          // eslint-disable-next-line no-console
          console.log('Zone', zone);
          zone.addWithUpdate(buttonGroup);
          resolve();
        });
      },
      { width: 48, height: 48 },
    );
  });
};
